import React from "react"
import { useEffect, useState, useCallback } from "react";

import StatusBar from "./statusbar"
import { DotLoader } from "react-spinners";
import "./transactiondetail.css";
import { useParams } from "react-router-dom";
import axios from "axios"
import { paths } from "../../../../../common/constants";
const DetailPage = (props) => {
  const [transaction, setTransaction] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const id = props.match.params.id

  const fetchTransaction = useCallback(async () => {
    try {
      const headers = {

      }

      const {
        data: { data },
      } = await axios.get(`/api/v2/admin/transactions/${id}`, { headers });

      setTransaction(data);

      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  }, [id]);

  useEffect(() => {
    fetchTransaction();
  }, [fetchTransaction]);

  // const handleUpdateStatus = async (statusText) => {
  //   try {
  //     const { data } = await detailPageApi.updateStatus(
  //       router.id,
  //       transaction.user_id,
  //       statusText
  //     );
  //     fetchTransaction();
  //     return data;
  //   } catch (error) {
  //     throw error;
  //   }
  // };

  return isLoading ? (
    <div className="vw-100 vh-100 d-flex align-items-center justify-content-center">
 <DotLoader sizeUnit="px" size={50} color="#00DD8C" />
    </div>
  ) : (
    <div className="detail-page pt-4">
      <div >
        <div className="dp__title display-6 mb-4">Transaction Detail</div>
        <span className="d-block mb-4">
          {/* <UpdateModal
            status={transaction.status_text}
            updateStatus={handleUpdateStatus}
          /> */}
        </span>
        <div className="dp__status p-3 p-xl-4 mb-4 border">
          <StatusBar status={transaction.status_text} />
        </div>
        <div className="dp__transaction p-3 p-xl-4 mb-4 border">
          <div className="transaction__title mb-2">Transaction Detail</div>
          <div className="transaction__container d-flex align-items-start flex-wrap">
            <div className="transaction__info mb-2">
              <div className="transaction__field ">ID</div>
              <div className="transaction__value">{transaction._id}</div>
            </div>
            <div className="transaction__info mb-2">
              <div className="transaction__field ">Currency</div>
              <div className="transaction__value">{transaction.currency}</div>
            </div>
            <div className="transaction__info mb-2">
              <div className="transaction__field ">Price</div>
              <div className="transaction__value">{transaction.price} $</div>
            </div>
            <div className="transaction__info mb-2">
              <div className="transaction__field ">Rating</div>
              <div className="transaction__value">
                {transaction.rating ? transaction.rating : "-"}
              </div>
            </div>
            <div className="transaction__info mb-2">
              <div className="transaction__field ">Status</div>
              <div className="transaction__value">
                {transaction.status_text}
              </div>
            </div>
            <div className="transaction__info mb-2">
              <div className="transaction__field ">Created At</div>
              <div className="transaction__value">
                {transaction.created_at}
              </div>
            </div>
            <div className="transaction__info mb-2">
              <div className="transaction__field ">Note</div>
              <div className="transaction__value">
                {transaction.description}
              </div>
            </div>
          </div>
        </div>
        <div className="dp__buyer p-3 p-xl-4 mb-4 border">
          <div className="buyer__title mb-2">Buyer Information</div>
          <div className="buyer__container d-flex align-items-start flex-wrap">
            <div className="buyer__info mb-2">
              <div className="buyer__field ">ID</div>
              <div className="buyer__value">
                {transaction.buyer && transaction.buyer._id}
              </div>
            </div>
            <div className="buyer__info mb-2">
              <div className="buyer__field ">Name</div>
              <div className="buyer__value">
                {transaction.buyer && transaction.buyer.display_name}
              </div>
            </div>
            <div className="buyer__info mb-2">
              <div className="buyer__field ">Email</div>
              <div className="buyer__value">
                {transaction.buyer && transaction.buyer.email}
              </div>
            </div>
            <div className="buyer__info mb-2">
              <div className="buyer__field ">Stripe</div>
              <div className="buyer__value">
                {transaction.buyer
                  ? transaction.buyer.stripe_account_id
                    ? transaction.buyer.stripe_account_id
                    : "-"
                  : "-"}
              </div>
            </div>
            <div className="buyer__info mb-2">
              <div className="buyer__field ">Paypal</div>
              <div className="buyer__value">
                <span>Payper ID:</span>{" "}
                <span>
                  {transaction.buyer
                    ? transaction.buyer.paypal_infos
                      ? transaction.buyer.paypal_infos.payer_id
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>Email:</span>{" "}
                <span>
                  {transaction.buyer
                    ? transaction.buyer.paypal_infos
                      ? transaction.buyer.paypal_infos.email
                      : "-"
                    : "-"}
                </span>
              </div>
            </div>

          </div>

          {transaction.buyer ? transaction.buyer.bank_infos ? <div className="buyer__container d-flex align-items-start flex-wrap">
            <div className="buyer__info mb-2">
              <div className="buyer__field ">Bank Information</div>
              <div className="buyer__value">
                <span>Routing number (AB/US SWIFT):</span>{" "}
                <span>
                  {transaction.buyer
                    ? transaction.buyer.bank_infos
                      ? transaction.buyer.bank_infos.bank_information.bank_routing_number
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>Recipient IBAN:</span>{" "}
                <span>
                  {transaction.buyer
                    ? transaction.buyer.bank_infos
                      ? transaction.buyer.bank_infos.bank_information.iban_number
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>Account Number:</span>{" "}
                <span>
                  {transaction.buyer
                    ? transaction.buyer.bank_infos
                      ? transaction.buyer.bank_infos.bank_information.account_number
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>Bank Country:</span>{" "}
                <span>
                  {transaction.buyer
                    ? transaction.buyer.bank_infos
                      ? transaction.buyer.bank_infos.bank_information.bank_country
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>Bank Address:</span>{" "}
                <span>
                  {transaction.buyer
                    ? transaction.buyer.bank_infos
                      ? transaction.buyer.bank_infos.bank_information.bank_address
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>City:</span>{" "}
                <span>
                  {transaction.buyer
                    ? transaction.buyer.bank_infos
                      ? transaction.buyer.bank_infos.bank_information.city
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>State:</span>{" "}
                <span>
                  {transaction.buyer
                    ? transaction.buyer.bank_infos
                      ? transaction.buyer.bank_infos.bank_information.state
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>Zipcode:</span>{" "}
                <span>
                  {transaction.buyer
                    ? transaction.buyer.bank_infos
                      ? transaction.buyer.bank_infos.bank_information.zip_code
                      : "-"
                    : "-"}
                </span>
              </div>
            </div>
            <div className="buyer__info mb-2">
              <div className="buyer__field ">Recipient Information</div>
              <div className="buyer__value">
                <span>Name:</span>{" "}
                <span>
                  {transaction.buyer
                    ? transaction.buyer.bank_infos
                      ? transaction.buyer.bank_infos.recipient_information.name
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>Nickname:</span>{" "}
                <span>
                  {transaction.buyer
                    ? transaction.buyer.bank_infos
                      ? transaction.buyer.bank_infos.recipient_information.nickname
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>Country:</span>{" "}
                <span>
                  {transaction.buyer
                    ? transaction.buyer.bank_infos
                      ? transaction.buyer.bank_infos.recipient_information.country
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>Address:</span>{" "}
                <span>
                  {transaction.buyer
                    ? transaction.buyer.bank_infos
                      ? transaction.buyer.bank_infos.recipient_information.address
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>City:</span>{" "}
                <span>
                  {transaction.buyer
                    ? transaction.buyer.bank_infos
                      ? transaction.buyer.bank_infos.recipient_information.city
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>State:</span>{" "}
                <span>
                  {transaction.buyer
                    ? transaction.buyer.bank_infos
                      ? transaction.buyer.bank_infos.recipient_information.state
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>Zipcode:</span>{" "}
                <span>
                  {transaction.buyer
                    ? transaction.buyer.bank_infos
                      ? transaction.buyer.bank_infos.recipient_information.zip_code
                      : "-"
                    : "-"}
                </span>
              </div>

            </div>
          </div> : <div className="buyer__info mb-2">  <div className="buyer__field ">Bank Information</div>
              <div className="buyer__value">
              -
              </div></div> : ""}



        </div>
        <div className="dp__seller p-3 p-xl-4 mb-4 border">
          <div className="seller__title mb-2">Seller Information</div>
          <div className="seller__container d-flex align-items-start flex-wrap">
            <div className="seller__info mb-2">
              <div className="seller__field ">ID</div>
              <div className="seller__value">
                {transaction.seller && transaction.seller._id}
              </div>
            </div>
            <div className="seller__info mb-2">
              <div className="seller__field ">Name</div>
              <div className="seller__value">
                {transaction.seller && transaction.seller.display_name}
              </div>
            </div>
            <div className="seller__info mb-2">
              <div className="seller__field ">Email</div>
              <div className="seller__value">
                {transaction.seller && transaction.seller.email}
              </div>
            </div>
            <div className="seller__info mb-2">
              <div className="seller__field ">Stripe</div>
              <div className="seller__value">
                {transaction.seller
                  ? transaction.seller.stripe_account_id
                    ? transaction.seller.stripe_account_id
                    : "-"
                  : "-"}
              </div>
            </div>
            <div className="seller__info mb-2">
              <div className="seller__field ">Paypal</div>
              <div className="seller__value">
                <span>Payper ID:</span>{" "}
                <span>
                  {transaction.seller
                    ? transaction.seller.paypal_infos
                      ? transaction.seller.paypal_infos.payer_id
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="seller__value">
                <span>Email:</span>{" "}
                <span>
                  {transaction.seller
                    ? transaction.seller.paypal_infos
                      ? transaction.seller.paypal_infos.email
                      : "-"
                    : "-"}
                </span>
              </div>
            </div>
           
          </div>
          {transaction.seller ? transaction.seller.bank_infos ? <div className="buyer__container d-flex align-items-start flex-wrap">
            <div className="buyer__info mb-2">
              <div className="buyer__field ">Bank Information</div>
              <div className="buyer__value">
                <span>Routing number (AB/US SWIFT):</span>{" "}
                <span>
                  {transaction.seller
                    ? transaction.seller.bank_infos
                      ? transaction.seller.bank_infos.bank_information.bank_routing_number
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>Recipient IBAN:</span>{" "}
                <span>
                  {transaction.seller
                    ? transaction.seller.bank_infos
                      ? transaction.seller.bank_infos.bank_information.iban_number
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>Account Number:</span>{" "}
                <span>
                  {transaction.seller
                    ? transaction.seller.bank_infos
                      ? transaction.seller.bank_infos.bank_information.account_number
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>Bank Country:</span>{" "}
                <span>
                  {transaction.seller
                    ? transaction.seller.bank_infos
                      ? transaction.seller.bank_infos.bank_information.bank_country
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>Bank Address:</span>{" "}
                <span>
                  {transaction.seller
                    ? transaction.seller.bank_infos
                      ? transaction.seller.bank_infos.bank_information.bank_address
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>City:</span>{" "}
                <span>
                  {transaction.seller
                    ? transaction.seller.bank_infos
                      ? transaction.seller.bank_infos.bank_information.city
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>State:</span>{" "}
                <span>
                  {transaction.seller
                    ? transaction.seller.bank_infos
                      ? transaction.seller.bank_infos.bank_information.state
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>Zipcode:</span>{" "}
                <span>
                  {transaction.seller
                    ? transaction.seller.bank_infos
                      ? transaction.seller.bank_infos.bank_information.zip_code
                      : "-"
                    : "-"}
                </span>
              </div>
            </div>
            <div className="buyer__info mb-2">
              <div className="buyer__field ">Recipient Information</div>
              <div className="buyer__value">
                <span>Name:</span>{" "}
                <span>
                  {transaction.seller
                    ? transaction.seller.bank_infos
                      ? transaction.seller.bank_infos.recipient_information.name
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>Nickname:</span>{" "}
                <span>
                  {transaction.seller
                    ? transaction.seller.bank_infos
                      ? transaction.seller.bank_infos.recipient_information.nickname
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>Country:</span>{" "}
                <span>
                  {transaction.seller
                    ? transaction.seller.bank_infos
                      ? transaction.seller.bank_infos.recipient_information.country
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>Address:</span>{" "}
                <span>
                  {transaction.seller
                    ? transaction.seller.bank_infos
                      ? transaction.seller.bank_infos.recipient_information.address
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>City:</span>{" "}
                <span>
                  {transaction.seller
                    ? transaction.seller.bank_infos
                      ? transaction.seller.bank_infos.recipient_information.city
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>State:</span>{" "}
                <span>
                  {transaction.seller
                    ? transaction.seller.bank_infos
                      ? transaction.seller.bank_infos.recipient_information.state
                      : "-"
                    : "-"}
                </span>
              </div>
              <div className="buyer__value">
                <span>Zipcode:</span>{" "}
                <span>
                  {transaction.seller
                    ? transaction.seller.bank_infos
                      ? transaction.seller.bank_infos.recipient_information.zip_code
                      : "-"
                    : "-"}
                </span>
              </div>

            </div>
          </div> : <div className="buyer__info mb-2">  <div className="buyer__field ">Bank Information</div>
              <div className="buyer__value">
              -
              </div></div> : ""}
        </div>
      </div>
    </div>
  );
};

export default DetailPage;



// WEBPACK FOOTER //
// ./client/react/Admin/views/TransactionDetail/index.js